// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2vwMz","actions":"GroupTable_actions__3xcPO","deleteModalFooter":"GroupTable_deleteModalFooter__3LsHF"};